module.exports = __webpack_public_path__ + "static/media/deathstar.bf01f41b.png";